const quotes = [
  {
    text: "Working with Mandie is unlike anything I have ever experienced. She is a clinician and a healer and a woman who genuinely sees you. I walked in carrying things I had held for decades. I do not carry them anymore.",
    name: "Gbemi, K",
  },
  {
    text: "She has a gift that cannot be taught. The psychology is there, the training is there, but what she does goes beyond all of that. She meets you in a place most people cannot reach.",
    name: "Tayo T",
  },
];

export default function AboutTestimonialsSection() {
  return (
    <section className="bg-[#6B1E3B] py-16 md:py-28 lg:py-32">
      <div className="w-full px-4 md:px-8 lg:px-12 max-w-5xl mx-auto">
        {/* Header */}
        <div className="text-center mb-14">
          <p className="text-[#C9A84C] text-xs font-body tracking-[0.25em] uppercase mb-6">
            What the women say
          </p>
          <h2 className="font-heading text-xl md:text-3xl lg:text-5xl text-[#FDFAF8] mb-10 leading-tight">
            She will take you somewhere
            <br />
            you cannot go alone.
          </h2>
        </div>

        {/* Gold Divider */}
        <div className="w-16 h-px bg-[#C9A84C] mx-auto mb-14" />

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-12">
          {quotes.map((q) => (
            <div
              key={q.text}
              className="bg-[#4A1430]/40 border border-[#3A1030]/30 rounded-lg p-6 md:p-10"
            >
              <p className="font-quote text-base md:text-lg italic text-[#F8EDF2] leading-relaxed mb-6">
                {q.text}
              </p>
              <p className="font-body text-sm font-medium text-[#C9A84C]">
                – {q.name}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}